/* eslint-disable prefer-template */
/* eslint-disable newline-after-var */
/* eslint-disable comma-dangle */
/* eslint-disable no-empty */
/* eslint-disable consistent-this */
/* eslint-disable object-shorthand */
/* eslint-disable no-var */
/* eslint-disable prefer-arrow-callback */
define('instrumentation/logs-queue-shim-local-storage', ['lib/underscore'],
    function (_) {
      var INDEX_START_KEY = 'LogsIndexStart';
      var INDEX_END_KEY = 'LogsIndexEnd';
      var LOG_KEY_PREFIX = 'Aria-Log-Entity-';

      return function LogQueue(options) {
        var logsArray = [];
        var queue = this;
        var isUsingLocalStorage = false;
        var infoMessages = [];

        var logStartIndex = 0;
        var logEndIndex = 0;

        function resetLocalStorageForClientSideLogs() {
          localStorage.setItem(INDEX_START_KEY, 0);
          localStorage.setItem(INDEX_END_KEY, 0);

          _.each(_.keys(localStorage), function(key) {
            if (key.indexOf(LOG_KEY_PREFIX) === 0) {
              localStorage.removeItem(key);
            }
          });
        }

        function safeGetStartIndex() {
          var startIndex = parseInt(localStorage.getItem(INDEX_START_KEY));
          if (!_.isNumber(startIndex)) {
            resetLocalStorageForClientSideLogs();
            return 0;
          }
          return startIndex;
        }

        function safeGetEndIndex() {
          var endIndex = parseInt(localStorage.getItem(INDEX_END_KEY));
          if (!_.isNumber(endIndex)) {
            resetLocalStorageForClientSideLogs();
            return 0;
          }
          return endIndex;
        }


        if (options.useLocalStorage && localStorage) {
          try {
            if (localStorage.getItem(INDEX_START_KEY) === null || localStorage.getItem(INDEX_END_KEY) === null) {
              localStorage.setItem(INDEX_START_KEY, logStartIndex);
              localStorage.setItem(INDEX_END_KEY, logEndIndex);
              infoMessages.push('Local Storage for aria log is initializing.');
            }

            logStartIndex = parseInt(localStorage.getItem(INDEX_START_KEY));
            logEndIndex = parseInt(localStorage.getItem(INDEX_END_KEY));

            if (_.isNumber(logStartIndex) && _.isNumber(logEndIndex) && logStartIndex >= 0 && logStartIndex <= logEndIndex) {
              isUsingLocalStorage = true;
            } else {
              // If somehow it enters here, the local storage is available but polluted. Try to initialize it again.
              infoMessages.push('Local Storage is not in expected state. StartIndex=' + localStorage.getItem(INDEX_START_KEY) + ', EndIndex=' + localStorage.getItem(INDEX_END_KEY));
              resetLocalStorageForClientSideLogs();
              infoMessages.push('Tried initializing Local Storage.');
            }
          } catch (e) {
            infoMessages.push('Local Storage is not available. Error:' + e.message);
          }
        }

        _.extend(queue, { isUsingLocalStorage: isUsingLocalStorage });

        _.extend(queue, { initializingMessages: infoMessages });

        if (isUsingLocalStorage) {
          _.extend(queue, {
            push: function (log) {
              logEndIndex = safeGetEndIndex();
              localStorage.setItem(LOG_KEY_PREFIX + logEndIndex, JSON.stringify(log));

              logEndIndex++;
              localStorage.setItem(INDEX_END_KEY, logEndIndex);
            },
            popMany: function (batchSize) {
              logStartIndex = safeGetStartIndex();
              var retrievedLogs = _.map(_.range(logStartIndex, logStartIndex + batchSize), function(logIndex) {
                try {
                  var logMessage = JSON.parse(localStorage.getItem(LOG_KEY_PREFIX + logIndex));
                  localStorage.removeItem(LOG_KEY_PREFIX + logIndex);
                  return logMessage;
                } catch (e) {
                  return null;
                }
              });

              if (window.BINGADS_DEBUG) {
                var logIds = _.map(retrievedLogs, function(log) {
                  return log && log.properties && log.properties.LogID && log.properties.LogID.value ? log.properties.LogID.value : '<Error>';
                }).join(',');
                window.console.log('Logs retrieved. batchSize=' + batchSize + 'LogIds=' + logIds);
              }

              // Reset the index so they won't infinitely increase.
              logStartIndex = logStartIndex + batchSize;
              if (logStartIndex === parseInt(localStorage.getItem(INDEX_END_KEY))) {
                resetLocalStorageForClientSideLogs();
              } else {
                localStorage.setItem(INDEX_START_KEY, logStartIndex);
              }

              return _.compact(retrievedLogs);
            },
            size: function() {
              return safeGetEndIndex() - safeGetStartIndex();
            }
          });
        } else {
          _.extend(queue, {
            push: logsArray.push,
            popMany: function(batchSize) {
              return logsArray.splice(0, batchSize);
            },
            size: function() {
              return logsArray.length;
            }
          });
        }
      };
    }
);
